/* Movatic WMS — Frontend | CesarFilho 932048016 */
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import CrudList from '@/components/CrudList'
import ProductImagesDialog from './components/ProductImagesDialog'

// Usa o caminho do .env quando definido; senão, cai no padrão do Django.
const PRODUCTS_ENDPOINT =
  (import.meta.env.VITE_API_PRODUCTS_PATH as string) || '/api/product/products/'

type ProductRow = { id: number; code: string; name1?: string }

export default function Products() {
  const navigate = useNavigate()
  const [imgFor, setImgFor] = useState<ProductRow | null>(null)
  return (
    <>
      <CrudList
        title="Produtos"
        endpoint={PRODUCTS_ENDPOINT}
        rowActions={(row: ProductRow) => (
          <div className="flex gap-2">
            <button
              className="btn subtle"
              onClick={() => navigate(`/catalog/products/${row.id}/edit`)}
            >
              Editar
            </button>
            <button className="btn subtle" onClick={() => setImgFor(row)}>
              Imagens
            </button>
          </div>
        )}
        columns={[
          { key: 'code', header: 'Código' },
          { key: 'variant', header: 'Var' },
          { key: 'name1', header: 'Nome' },
          { key: 'uom', header: 'UM' },
          { key: 'storage_class', header: 'Classe' },
        ]}
      />
      {imgFor && (
        <ProductImagesDialog
          product={imgFor}
          open
          onClose={() => setImgFor(null)}
        />
      )}
    </>
  )
}
